// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__1F-79","topBottomGutter":"Layout_topBottomGutter__1LoXP"};